import type { TokenParam } from './tokenResponse';
import type { MailboxTypeHint } from 'owa-account-source-list-types';

export type ResourceTokenRequestParams = {
    userId: string;
    typeHint: MailboxTypeHint;
    resource: string;
    correlationId: string;
    wwwAuthenticateHeaderValue?: string;
    scope?: string;
    naa?: NestedAppAuthTokenRequest;
    additionalParameters?: TokenParam[];
};

export type CredentialParam = {
    name: string;
    value: string;
};

export type NestedAppAuthTokenRequest = {
    platformBrokerId?: string;
    clientId: string;
    redirectUrl: string;
    authority?: string;
    scope: string;
    correlationId?: string;
    claims?: string;
    state?: string;
    reqCnf?: string;
    keyId?: string;
    authenticationScheme?: string;
    shrClaims?: string;
    shrNonce?: string;
    resourceRequestMethod?: string;
    resourceRequestUri?: string;
    extendedExpiryToken?: boolean;
    extraParameters?: CredentialParam[];
};

export enum CredentialSecretType {
    Token = 'Token',
    Password = 'Password',
    Secret = 'Secret',
    Other = 'Other',
}

export type CredentialRequestParams = {
    userId: string;
    identityProviderHint: MailboxTypeHint;
    resource: string;
    correlationId: string;
    uniqueIdentifier?: string;
    credentialSecretType: CredentialSecretType;
    wwwAuthenticateHeaderValue?: string;
    scope?: string;
    additionalParameters?: CredentialParam[];
};
